import { CreateShiftTypeForm } from '@/services/Calendar/ShiftType/forms/CreateShiftTypeForm';

export class EditShiftTypeForm extends CreateShiftTypeForm {
}
